// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@west/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import NotificationTooltip from "@west/XDL/Icons/NotificationTooltip";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    gap: 16,
};

creditCardDetailsEntryStyles.securityCodeTokenExFrame = {
    labelProps: {
        mergeCss: true,
        css: css`
            display: inline-flex;
            gap: 4px;
            align-items: center;
            max-height: 14px;
            min-height: initial;
        `,
    },
};

creditCardDetailsEntryStyles.expirationMonthGridItemOnePageCheckout = {
    width: [5, 4, 4, 4, 4],
};

creditCardDetailsEntryStyles.expirationYearGridItemOnePageCheckout = {
    width: [5, 4, 4, 4, 4],
};

creditCardDetailsEntryStyles.securityCodeGridItemOnePageCheckout = {
    width: [5, 4, 4, 4, 4],
};
